:host {
  display: block;
}

:host([fixed]) {
  position: fixed;
  width: 100%;
  z-index: 999;
}

::slotted([slot=nav-items]) {
  @apply mx-3 text-[15px] md:leading-[30px] self-center;
}

nav {
  @apply w-full min-h-[90px] flex justify-between items-center;
  max-width: var(--vt-page-container-width, 1200px);
}

div.submenu-wrapper {
  @apply w-full h-full min-h-full flex bg-white;
  max-width: var(--vt-page-container-width, 1200px);
}
